import {mapState, mapWritableState} from "pinia";
import {useCategoriesStore} from "@/stores/CategoriesStore";
import Constants from "@/assets/js/constants";
import MixinStringManipulation from "@/mixins/MixinStringManipulation";

let isLocalhost;

if (window.location.hostname.indexOf('localhost') !== -1 && window.location.port === '8080') {
    // For running commands via ssh, local otherwise for production
    isLocalhost = true;
} else {
    isLocalhost = false;
}

export default {
    mixins: [MixinStringManipulation],
    computed: {
        ...mapState(useCategoriesStore, {
            profiles: 'profiles',
        })
    }, methods: {

        /** All methods here should have a prefix of config for code organisation purpose. */
        configCategoriesGetDefaultProfileId() {

            let self = this;
            let profileId = false;

            self.profiles.forEach((profile) => {
                if (profile.profile_name === Constants.defaultProfileName && ! profileId) {
                    profileId = profile.profile_id
                }
            });

            return profileId;

        },

        generateUniqueProfileId() {

            let self = this;

            let profileId = Date.now() + '_' + self.generateRandomString(10)
            let found = false;

            self.profiles.forEach((profile) => {

                if (profile.profile_id === profileId && ! found) {
                    found = true;
                }

            });

            if (found) {
                return self.generateUniqueProfileId();
            }

            return profileId;

        }

    }

}
